/** The screen a path is, for the bug report's history: its section, and on /admin the tab too. */
export function screenOf(pathname: string): string {
  const [section, tab] = pathname.split("/").slice(1);
  if (!section) return "home";
  return section === "admin" ? `admin/${tab || "sites"}` : section;
}
